import { HttpInjector } from '@/cowboy/http/HttpInjector'
import { RewardLinkResponse } from '@/cowboy/reward_link/object/RewardLinkResponse'

export class RewardLinkApi extends HttpInjector {
  /**
   * Fetch stored value object representing the current RewardLink
   * @return {Promise<RewardLinkResponse>}
   */
  static async fetchStoredValue () {
    const response = await this.$http.get(`/sv/${this.codeVersion.requestCode}?urlVersion=${this.codeVersion.urlVersion}`)
    return this.cast(response.data, RewardLinkResponse)
  }
}
